import { Box } from "@mui/material";
import { PaperTitle } from "Components/Shared/PaperTitle";
import { RelatedPartiesAccordionList } from "Components/Users/UserDetailPageContent/Components/RelatedPartyForm/RelatedPartiesAccordionList";
import type { RelatedPartyDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const COMPONENT_RESOURCES =
  Resources.Pages.Content.UserDetailPageContent.Tabs.RelatedParties;

type RelatedPartiesProps = {
  relatedParties: Array<RelatedPartyDto>;
  owningPartyID?: string | null;
};

export const RelatedParties = ({
  relatedParties,
  owningPartyID,
}: RelatedPartiesProps) => {
  const { t } = useResource();

  return (
    <>
      <PaperTitle>{t(COMPONENT_RESOURCES.Title)}</PaperTitle>
      <Box mt={5}>
        <RelatedPartiesAccordionList
          relatedParties={relatedParties}
          owningPartyID={owningPartyID}
        />
      </Box>
    </>
  );
};
